
import ProductsList from '@/graphql/queries/products/ProductsList'

export default {
  vessel: {
    carousel: {
      position: 'relative'
    },
    overlay: {
      position: 'absolute',
      width: 'full',
      pinTop: true,
      pointerEvents: 'none'
    },
    icon: {
      pointerEvents: 'auto',
      color: 'blue',
      padding: 'xs',
      fontSize: '2xl',
      backgroundColor: 'white',
      borderRadius: 'full',
      cursor: 'pointer',
      shadow: true
    }
  },
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: ProductsList,
      variables: { first: 6 }
    })

    this.products = data.nodes
  },
  data() {
    return {
      products: null
    }
  }
}
